import React from 'react';
import { useTranslation } from 'react-i18next';
import { EpisodeAsset } from '../../../queries/ats/titles/types/asset';
import { Source } from '../../../queries/ats/titles/types/sources';
import { details } from '../../../routes/routes';
import { DetailsLink } from '../details-link';
import { useDetailsParams } from '../utils';
import css from './details-subtitle.module.scss';

interface DetailsSubtitleProps {
  asset: EpisodeAsset;
  source: Source;
}

export function DetailsSubtitle({ asset, source }: DetailsSubtitleProps) {
  const { t } = useTranslation();

  return (
    <span className={css.container}>
      <DetailsSeriesButton asset={asset} source={source} className={css.primary}>
        {asset.series.titleName}
      </DetailsSeriesButton>
      <span className={css.secondary}>
        {t('common:season', { value: asset.season.sequenceNumber })} •{' '}
        {t('common:episode', { value: asset.episode.sequenceNumber })}
      </span>
    </span>
  );
}

interface DetailsSeriesButtonProps {
  children: React.ReactNode;
  asset: EpisodeAsset;
  source: Source;
  className?: string;
}

function DetailsSeriesButton({ children, asset, source, className }: DetailsSeriesButtonProps) {
  const params = useDetailsParams();
  const isRecording = details.isRecording(asset);

  const id = isRecording ? params.id : asset.series.masterId;
  const type = isRecording ? 'recording' : 'series';
  const subType = isRecording ? 'series' : undefined;

  return (
    <DetailsLink className={className} id={id} type={type} subType={subType} params={{ orderByProviderId: source.id }}>
      {children}
    </DetailsLink>
  );
}
